import { render, staticRenderFns } from "./ValueSymbiosis.vue?vue&type=template&id=8216dd74&scoped=true&"
import script from "./ValueSymbiosis.vue?vue&type=script&lang=js&"
export * from "./ValueSymbiosis.vue?vue&type=script&lang=js&"
import style0 from "./ValueSymbiosis.vue?vue&type=style&index=0&id=8216dd74&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8216dd74",
  null
  
)

export default component.exports